var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFloralDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3925.9 3608.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke: #000;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-1, .cls-4 {\n        stroke-width: 8.5px;\n      }\n\n      .cls-1, .cls-4, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-5, .cls-6 {\n        stroke-width: 9.07px;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-6 {\n        stroke-linejoin: round;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m2035.19,3213.14c621.06,0,966.32,0,1191.82-225.5,225.5-225.5,225.5-570.76,225.5-1191.82s0-966.32-225.5-1191.82c-225.5-225.5-570.76-225.5-1191.82-225.5s-966.32,0-1191.82,225.5c-225.5,225.5-225.5,570.76-225.5,1191.82s0,966.32,225.5,1191.82c225.5,225.5,570.76,225.5,1191.82,225.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m2035.19,3388.11c698.27,0,1086.44,0,1339.97-253.53,253.53-253.53,253.53-641.71,253.53-1339.97s0-1086.44-253.53-1339.97c-253.53-253.53-641.71-253.53-1339.97-253.53s-1086.44,0-1339.97,253.53c-253.53,253.53-253.53,641.71-253.53,1339.97s0,1086.44,253.53,1339.97c253.53,253.53,641.71,253.53,1339.97,253.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1271.48,3178.97c21.71-6.38,42.17-18.13,59.29-35.25,54.56-54.56,54.56-143.02,0-197.58,29.66-29.66,43.2-69.35,40.61-108.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1123.82,3152.29c3.22-2.69,6.35-5.54,9.37-8.57h0c5.25,5.25,10.81,9.99,16.63,14.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m902.55,2801.07c-17.19,49.08-6.17,105.84,33.07,145.07-24.45,24.45-37.95,55.72-40.48,87.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m978.36,2719.33c-15.51,6.79-30.05,16.53-42.74,29.23-15.33,15.33-26.35,33.33-33.07,52.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-2",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1844.56,431.52c-42.75-6.85-88.07,6.19-121.02,39.15h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1492.89,523.17c-17.19,49.08-6.17,105.84,33.07,145.07-31.99,31.99-45.22,75.62-39.7,117.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1723.54,470.66c-54.56-54.56-143.02-54.56-197.58,0-15.33,15.33-26.35,33.33-33.07,52.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-3",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1842.51,862.56c-7.77-10.38-16.38-20.34-25.82-29.78-107.07-107.07-280.66-107.08-387.73,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m976.32,935.82c-5.3,15.13-9.23,30.63-11.8,46.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1428.96,832.78c-107.07-107.07-280.67-107.07-387.74,0-30.08,30.08-51.71,65.41-64.89,103.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-4",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1077.32,1340.95c8.52-44.03-4.26-91.37-38.36-125.47,54.56-54.56,54.56-143.02,0-197.58-54.56-54.56-143.02-54.56-197.58,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m630.17,1199.67c4.08,5.52,8.63,10.8,13.63,15.81-6.41,6.41-12.07,13.29-16.97,20.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m841.38,1017.9c-51.15-51.15-132.1-54.35-186.97-9.59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-5",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2812.32,423.61c-.39-3.34-.85-6.67-1.36-9.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1853.18,377.79c-27.94,96.48-3.89,204.83,72.16,280.87-83.42,83.42-104.27,205.71-62.56,308.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-6",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1543.75,1513.11c-6.72,19.18-11.29,38.93-13.72,58.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1758.31,1329.77c-54.23,9.89-106.12,35.8-148.05,77.73-30.83,30.83-53,67.04-66.51,105.61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-7",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1306.44,1570.57c-8.33-56.14-34.1-110.19-77.31-153.4-107.07-107.07-280.66-107.08-387.73,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m841.39,1417.16c-59.81-59.81-140.38-86.21-218.52-79.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-8",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m2192.33,3208.59c1.86-8.5,3.34-17.07,4.42-25.67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-9",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2954.73,441.11c-8.7,5.47-16.93,12-24.51,19.57h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3073.48,889.53c19.85-6.65,38.51-17.88,54.32-33.69,54.56-54.56,54.56-143.02,0-197.58,27.28-27.28,40.92-63.03,40.92-98.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2699.57,513.19c-17.19,49.08-6.17,105.84,33.07,145.07-34.1,34.1-46.89,81.44-38.36,125.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2930.22,460.68c-54.56-54.56-143.02-54.56-197.58,0-15.33,15.33-26.35,33.33-33.07,52.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-10",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2086.75,2801.07c-17.19,49.08-6.17,105.84,33.07,145.07-54.56,54.56-54.56,143.02,0,197.58,54.56,54.56,143.02,54.56,197.58,0h0c54.56,54.56,143.02,54.56,197.58,0,54.56-54.56,54.56-143.02,0-197.58,27.93-27.93,41.57-64.75,40.9-101.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2174.39,2714.79c-19.95,6.64-38.69,17.89-54.57,33.77-15.33,15.33-26.35,33.33-33.07,52.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-11",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2160.49,958.68c-49.9-12.55-104.95.69-143.98,39.72h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1766.81,1055.24c-18.61,53.13-6.67,114.58,35.8,157.05-59.07,59.07-59.07,154.83,0,213.9,59.07,59.07,154.83,59.07,213.9,0h0c38.1,38.1,91.46,51.62,140.4,40.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2016.51,998.39c-59.07-59.07-154.83-59.07-213.9,0-16.59,16.59-28.53,36.09-35.8,56.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-12",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3106.45,976.98c-9.92-52.82-35.81-103.34-77.67-144.18-109.73-107.07-287.63-107.08-397.36,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2849.66,1687.91c65.26-4.42,129.24-30.96,179.13-79.65,44.52-43.44,70.97-97.83,79.37-154.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2156.87,1466.61c10.27,51.9,35.99,101.47,77.19,141.66,40.24,39.27,89.66,64.14,141.52,74.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2167.55,935.84c-34.57,96.32-12.4,207.71,66.5,284.7-68.54,66.88-94.27,159.71-77.19,246.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2631.43,832.79c-109.73-107.07-287.64-107.07-397.37,0-30.83,30.08-53,65.41-66.5,103.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-13",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3413.48,1008.4c-54.87-44.85-135.89-41.69-187.08,9.5h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3437.53,1231.18c-4.07-5.48-8.58-10.74-13.56-15.71,4.41-4.41,8.47-9.05,12.17-13.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2995.75,1070.4c-17.19,49.08-6.17,105.84,33.07,145.07-54.56,54.56-54.56,143.02,0,197.58,54.56,54.56,143.02,54.56,197.58,0h0c54.56,54.56,143.02,54.56,197.58,0,8.12-8.12,15.03-17,20.74-26.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3226.4,1017.9c-54.56-54.56-143.02-54.56-197.58,0-15.33,15.33-26.35,33.33-33.07,52.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-14",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1878.07,2145.24c-12.15-44.43-35.67-86.4-70.57-121.31-44.31-44.32-100.03-70.29-157.7-77.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1371.37,2838c17.19-10.78,33.44-23.64,48.39-38.59h0c107.07,107.07,280.67,107.06,387.73,0,38.85-38.85,63.6-86.45,74.26-136.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m953.96,2640.66c7.46,58.05,33.48,114.16,78.06,158.74,92.12,92.12,233.48,104.98,339.35,38.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m967.13,2126.97c-4.22,12.04-7.57,24.31-10.05,36.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1168.02,1949.76c-49.84,10.71-97.27,35.43-136,74.16-30.08,30.08-51.71,65.41-64.89,103.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-15",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2159.69,2152.19c-52.03-16.34-111.15-3.89-152.38,37.34h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1882.33,2660.56c44.47,5.31,90.85-9.1,124.98-43.23h0c40.35,40.35,97.84,53.14,149.04,38.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1757.62,2246.38c-18.61,53.13-6.67,114.58,35.8,157.05-59.07,59.07-59.07,154.83,0,213.9,24.94,24.94,56.42,39.35,88.92,43.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2007.31,2189.54c-59.07-59.07-154.83-59.07-213.9,0-16.59,16.59-28.53,36.09-35.8,56.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-16",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3084.18,2173.07c-8.98-54.6-34.53-107.01-76.64-149.13-45.52-45.52-103.06-71.69-162.41-78.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2156.35,2655.67c9.74,52.66,34.98,103.02,75.71,143.75,107.07,107.07,280.67,107.07,387.74,0h0c107.07,107.07,280.67,107.06,387.73,0,44.59-44.59,70.61-100.72,78.06-158.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2167.17,2126.98c-33.73,96.32-12.1,207.71,64.89,284.7-66.34,66.34-91.58,158.22-75.71,244"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2382.52,1947.07c-55.08,8.79-108,34.41-150.45,76.86-30.08,30.08-51.71,65.41-64.89,103.05"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-17",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3445.09,2276.17c-5.7-24.6-18.13-47.96-37.3-67.13-54.56-54.56-143.02-54.56-197.58,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3431.53,2438.23c-6.22-11.34-14.14-22-23.75-31.61,15.86-15.85,27.1-34.57,33.74-54.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2979.56,2261.55c-17.19,49.08-6.17,105.84,33.07,145.07-54.56,54.56-54.56,143.02,0,197.58,54.56,54.56,143.02,54.56,197.58,0h0c54.56,54.56,143.02,54.56,197.58,0,3.32-3.32,6.44-6.76,9.35-10.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3210.21,2209.04c-54.56-54.56-143.02-54.56-197.58,0-15.33,15.33-26.35,33.33-33.07,52.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-18",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1081.44,2269.35c-5.96-23.62-18.18-45.99-36.66-64.47-54.56-54.56-143.02-54.56-197.58,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m660.23,2609.62c54.87,44.76,135.82,41.56,186.97-9.59h0c54.56,54.56,143.02,54.56,197.58,0,54.56-54.56,54.56-143.02,0-197.58,36.08-36.08,48.3-86.98,36.67-133.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m632.86,2382.23c4.86,7.13,10.44,13.9,16.77,20.22-5.64,5.64-10.7,11.64-15.17,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m847.2,2204.87c-54.56-54.56-143.02-54.56-197.58,0-10.57,10.57-19.09,22.42-25.57,35.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-19",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2383.43,1670.49c-17.19,49.08-6.17,105.84,33.07,145.07-54.56,54.56-54.56,143.02,0,197.58,54.56,54.56,143.02,54.56,197.58,0h0c54.56,54.56,143.02,54.56,197.58,0,54.56-54.56,54.56-143.02,0-197.58,54.56-54.56,54.56-143.02,0-197.58-54.56-54.56-143.02-54.56-197.58,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2614.08,1617.98c-54.56-54.56-143.02-54.56-197.58,0-15.33,15.33-26.35,33.33-33.07,52.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-20",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1649.79,1946.01c9.69-45.8-3.25-95.44-38.83-131.01,55.92-55.91,55.92-146.57,0-202.48-55.91-55.92-146.57-55.92-202.48,0h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1172.11,1666.32c-17.61,50.3-6.32,108.47,33.89,148.68-55.92,55.92-55.92,146.57,0,202.49,55.92,55.92,146.57,55.92,202.49,0h0c55.92,55.91,146.57,55.91,202.48,0,20.34-20.34,33.28-45.28,38.82-71.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1408.49,1612.5c-55.92-55.92-146.57-55.92-202.49,0-15.71,15.71-27.01,34.16-33.89,53.81"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m978.33,668.81c4.41,6.57,8.82,13.13,13.23,19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1337.59,668.16h-29.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1308.4,689.15h29.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1026.75,
    y1: 673.45,
    x2: 1050.11,
    y2: 673.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m913.15,647.59v41.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m960.98,647.69v41.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 893.19,
    y1: 647.59,
    x2: 933.1,
    y2: 647.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1253.97,647.59v41.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1234.02,
    y1: 647.59,
    x2: 1273.93,
    y2: 647.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1308.22,648.11v41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1308.22,647.24h29.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m960.98,647.69h17.35c6.06.48,10.52,5.75,10.09,11.38-.39,5.07-4.66,9.34-10.09,9.74h-15.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1085.89,688.76v-41.11c.78.38,1.93.91,3.32,1.51,6.95,2.98,15.14,6.51,25.1,6.65,12.99.18,22.54-4.4,26.61-6.65,1.16-.54,2.32-1.08,3.49-1.62v41.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1181.34,668.74h15.84c5.43-.39,9.71-4.67,10.09-9.74.43-5.63-4.03-10.9-10.09-11.38h-17.35v41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1020.64,688.73l6.11-16.14c3.3-8.36,6.61-16.73,9.91-25.09,1.32,0,2.65,0,3.97,0,3.09,8.12,6.17,16.27,9.24,24.45,2.1,5.6,4.19,11.19,6.27,16.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1403.56,659.39c-2.58-7.31-9.33-12.35-17-12.72-7.92-.38-15.31,4.28-18.43,11.65-.87,2.26-2.05,6.24-1.72,11.24.23,3.53,1.13,6.37,1.92,8.31,3.32,6.98,10.55,11.28,18.23,10.84,7.83-.45,14.62-5.74,17-13.25"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3043.22,2965.84c-4.41-6.57-8.82-13.13-13.23-19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2683.96,2966.49h29.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2713.15,2945.5c-9.67,0-19.35,0-29.02,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 2994.79,
    y1: 2961.2,
    x2: 2971.44,
    y2: 2961.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3108.4,2987.05c0-13.71,0-27.42,0-41.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3060.57,2986.96c0-13.68,0-27.36,0-41.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3128.36,
    y1: 2987.05,
    x2: 3088.45,
    y2: 2987.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2767.58,2987.05c0-13.71,0-27.42,0-41.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2787.53,
    y1: 2987.05,
    x2: 2747.62,
    y2: 2987.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2713.32,2986.54c0-13.68,0-27.36,0-41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2713.32,2987.41c-9.67,0-19.35,0-29.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m3060.57,2986.96h-17.35c-6.06-.48-10.52-5.75-10.09-11.38.39-5.07,4.66-9.34,10.09-9.74,5.28,0,10.56,0,15.84,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2935.66,2945.89c0,13.7,0,27.41,0,41.11-.78-.38-1.93-.91-3.32-1.51-6.95-2.98-15.14-6.51-25.1-6.65-12.99-.18-22.54,4.4-26.61,6.65-1.16.54-2.32,1.08-3.49,1.62,0-13.73,0-27.46,0-41.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2840.21,2965.91c-5.28,0-10.56,0-15.84,0-5.43.39-9.71,4.67-10.09,9.74-.43,5.63,4.03,10.9,10.09,11.38h17.35c0-13.68,0-27.36,0-41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3000.9,2945.92l-6.11,16.14c-3.3,8.36-6.61,16.73-9.91,25.09-1.32,0-2.65,0-3.97,0-3.09-8.12-6.17-16.27-9.24-24.45-2.1-5.6-4.19-11.19-6.27-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2617.99,2975.26c2.58,7.31,9.33,12.35,17,12.72,7.92.38,15.31-4.28,18.43-11.65.87-2.26,2.05-6.24,1.72-11.24-.23-3.53-1.13-6.37-1.92-8.31-3.32-6.98-10.55-11.28-18.23-10.84-7.83.45-14.62,5.74-17,13.25"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1721.84,
    cy: 667.09,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 841.38,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 841.38,
    cy: 2411.1,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1422.71,
    cy: 2411.1,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2001.42,
    cy: 2410.59,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2622.76,
    cy: 2411.67,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 3207.91,
    cy: 2411.67,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 847.61,
    cy: 1221.04,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1428.95,
    cy: 1221.04,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2007.65,
    cy: 1220.52,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2628.99,
    cy: 1221.6,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 3214.14,
    cy: 1221.6,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1133.19,
    cy: 2945.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1720.09,
    cy: 2945.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2320.23,
    cy: 2945.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1410.4,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2002.76,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2614.07,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 3207.91,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2320.55,
    cy: 667.09,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 2921.21,
    cy: 667.09,
    rx: 36.85,
    ry: 36.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloralDesign);
export default __webpack_public_path__ + "static/media/floralDesign.c041feec07dc0eb44e9a17185ffb360f.svg";
export { ForwardRef as ReactComponent };